import React from 'react'
import { Header } from 'components'
import { Link } from 'react-router-dom'

const Session = () => {
  return (
    <div>
      <Header />

      <div style={{
        padding: '3.5rem 12.5rem',
      }}>

        {/* TITLE */}
        <div style={{ fontFamily: 'MerriWeather-SemiBold', fontSize: '2rem', lineHeight: '1.5', textAlign: 'center' }}>
          A Session with <br />
          The Professional
        </div>

        {/* INTRO */}
        <div style={{ lineHeight: '1.5', textAlign: 'center', margin: '3rem 2.5rem 0 2.5rem' }}>
          <span style={{ fontFamily: 'MerriWeather-Medium', fontSize: '1.5rem' }}>
            "What if I made figures for each stage of grief?"
          </span>
          <br />
          <span style={{ fontFamily: 'MerriWeather-Light', fontSize: '1.25rem' }}>
            That was the question one of my students asked during a brainstorming session. As a psychologist, I’m used to exploring grief through emotional expression, cognitive understanding, and relational support—but this question invited me to approach it differently. It made me wonder: What would grief look like if we could see it?
          </span>
        </div>

        {/* 1ST W/ KV */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 3fr',
          marginTop: '3.5rem',
          columnGap: '2.5rem',
        }}>
          <div style={{ flex: '1' }}>
            <img src="/grieflings-masonry.png" alt="Key Visual" style={{ width: '100%' }} />
          </div>
          <div style={{
            flex: '1',
            fontFamily: 'MerriWeather-Light',
            fontSize: '1.25rem',
            lineHeight: '1.5',
            display: 'flex',
            flexDirection: 'column',
            rowGap: '1.5rem',
          }}>
            <div>
              As we talked, it became clear that each phase in the grieving process carries a distinct emotional tone:
            </div>
            <div>
              There is <span style={{ fontFamily: 'MerriWeather-Bold' }}>denial</span> as the initial response—when the loss feels too overwhelming to fully grasp.
            </div>
            <div>
              Then comes <span style={{ fontFamily: 'MerriWeather-Bold' }}>anger</span>, emerging as a reaction to the perceived unfairness or disruption the loss brings.
            </div>
            <div>
              Next is <span style={{ fontFamily: 'MerriWeather-Bold' }}>bargaining</span>, often filled with “what if” thoughts—a mental negotiation in hopes of altering or undoing the outcome.
            </div>
            <div>
              Then the weight of the loss sinks in, bringing about a <span style={{ fontFamily: 'MerriWeather-Bold' }}>depressive</span> phase, where energy is low and emotions are heavy.
            </div>
            <div>
              Finally, there is <span style={{ fontFamily: 'MerriWeather-Bold' }}>acceptance</span>, a quieter stage where individuals begin to acknowledge the loss and adapt to a changed reality.
            </div>
          </div>
        </div>

        {/* 2ND W/ KV */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '3fr 2fr',
          marginTop: '3.5rem',
          columnGap: '2.5rem',
        }}>
          <div style={{
            flex: '1',
            fontFamily: 'MerriWeather-Light',
            fontSize: '1.25rem',
            lineHeight: '1.5',
            display: 'flex',
            flexDirection: 'column',
            rowGap: '1.5rem',
          }}>
            <div>
              Our discussion focused not just on naming these phases, but on what it feels like to live through them. We noticed how often people who grieve are pressured to appear “strong,” or to move on quickly. Yet healing doesn't come from rushing the process. It comes from recognizing and validating each stage—without judgment, without urgency.
            </div>
            <div>
              Through this project, my student explored how visual representations could serve as companions in grief. These figures are not here to say “don’t be sad,” “stop being angry,” or “cheer up.” Instead, they represent presence—something or someone who stays, even when things don’t feel okay.
            </div>
          </div>
          <div style={{ flex: '1' }}>
            <img src="/discussion-kv.png" alt="Key Visual" style={{ width: '100%', borderRadius: '1rem' }} />
          </div>
        </div>

        {/* CONCLUSION */}
        <div style={{
          marginTop: '2.5rem',
          lineHeight: '1.5',
          display: 'flex',
          flexDirection: 'column',
          rowGap: '1.5rem',
        }}>
          <div style={{ fontFamily: 'MerriWeather-Light', fontSize: '1.25rem' }}>
            As a psychologist, I often say:
          </div>
          <div style={{ fontFamily: 'MerriWeather-Medium', fontSize: '1.25rem' }}>
            Grieving is not a weakness. It’s a human process. When it’s given space to unfold, it helps people integrate their loss, rather than carry it in silence. And sometimes, visualizing that process—seeing it reflected back to us—can offer comfort, clarity, or even the courage to keep going. 
          </div>
          <div style={{ fontFamily: 'MerriWeather-Light', fontSize: '1.25rem' }}>
            If you are navigating your own grief journey, I hope this project reminds you: you’re not alone. And if at any point you feel overwhelmed or unsure, reaching out to a mental health professional may help you make sense of what you’re carrying.
          </div>
        </div>

        {/* CONNECT */}
        <div style={{
          marginTop: '10rem',
          lineHeight: '1.5',
          display: 'flex',
          flexDirection: 'column',
          rowGap: '0.5rem',
          textAlign: 'right',
        }}>
          <div style={{ fontFamily: 'MerriWeather-Medium', fontSize: '1rem' }}>
            You can connect with support at {' '}
            <Link to="https://www.instagram.com/sadari_diri/" target='_blank'>
              @sadari_diri.
            </Link>
          </div>
          <div style={{ fontFamily: 'MerriWeather-Medium', fontSize: '0.85rem', color: '#868686' }}>
            Embrace the Journey, Illuminate the Shadows.
          </div>
        </div>

      </div>
    </div>
  )
}

export default Session
